module.exports = __webpack_public_path__ + "static/media/Social Proof.e73205c2.jpg";